<template>
  <BreadCrumb PageTitle="Tableau de bord Transitaire" />
  <TransitaireDashboard />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TransitaireDashboard from "@/components/Transitaire/TransitaireDashboard.vue";

export default defineComponent({
  name: "TransitaireDashboardPage",
  components: {
    BreadCrumb,
    TransitaireDashboard,
  },
});
</script>